export default "__VITE_ASSET__CYKnqzFU__"